import { render, staticRenderFns } from "./BnRendezoSav.vue?vue&type=template&id=71800c4a&scoped=true&"
import script from "./BnRendezoSav.vue?vue&type=script&lang=js&"
export * from "./BnRendezoSav.vue?vue&type=script&lang=js&"
import style0 from "./BnRendezoSav.vue?vue&type=style&index=0&id=71800c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71800c4a",
  null
  
)

export default component.exports